import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/v2`;

function SystemAdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // First, try to login
      const response = await axios.post(`${API}/auth/system-login`, {
        email: email.toLowerCase(),
        password
      });

      if (response.data.token) {
        localStorage.setItem('systemklart_token', response.data.token);
        localStorage.setItem('systemklart_user', JSON.stringify(response.data.user));
        if (response.data.organization) {
          localStorage.setItem('systemklart_org', JSON.stringify(response.data.organization));
        }
        
        toast.success('Velkommen, systemadministrator');
        
        // Force reload to update AuthContext
        window.location.href = '/system-admin';
      }
    } catch (error) {
      const detail = error.response?.data?.detail || 'Innlogging feilet';
      toast.error(detail);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo & Title */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-red-600 rounded-xl mb-4">
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-white">Systemadministrasjon</h1>
          <p className="text-gray-400 mt-2">Kun for autoriserte administratorer</p>
        </div>

        {/* Login Form */}
        <div className="bg-gray-800 rounded-xl p-6 border border-gray-700">
          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-1">
                E-post
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 bg-gray-900 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:ring-2 focus:ring-red-500 focus:border-red-500"
                placeholder="admin@example.com"
                required
                data-testid="system-login-email"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-300 mb-1">
                Passord
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 bg-gray-900 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:ring-2 focus:ring-red-500 focus:border-red-500"
                placeholder="••••••••"
                required
                data-testid="system-login-password"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50"
              data-testid="system-login-submit"
            >
              {loading ? 'Logger inn...' : 'Logg inn som systemadmin'}
            </button>
          </form>
        </div>

        {/* Back link */}
        <div className="text-center mt-6">
          <button
            onClick={() => navigate('/login')}
            className="text-sm text-gray-500 hover:text-gray-300"
          >
            ← Tilbake til vanlig innlogging
          </button>
        </div>

        {/* Security note */}
        <div className="mt-8 text-center">
          <p className="text-xs text-gray-600">
            Dette er et sikret område. Alle innloggingsforsøk logges.
          </p>
        </div>
      </div>
    </div>
  );
}

export default SystemAdminLogin;
